import { FC } from 'react';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { usePwcNavigate } from '@app/core/hooks/routing-hooks';
import PwcNavigate from '@app/shared/routing/PwcNavigate';
import { RouteConstants } from '../../RouteConstants';
import useIsCapApplied from '@app/shared/hooks/useIsCapApplied';

export const OpmWaterfallPage: FC = (): JSX.Element => {
  const storedOpmWaterfallTab = useAppSelector(
    (state) => state.uiValues.userSelections.opmWaterfall.selectedTab
  );
  const { generatePath } = usePwcNavigate();

  // TODO: delete the below contingency on Caps when 4.0 is due to be released
  // TODO: as this is a temporary implementation relating to Network Rollout
  const isCapApplied = useIsCapApplied();

  let selectedTab = storedOpmWaterfallTab ?? RouteConstants.FirstLastSimulations;

  if (isCapApplied && storedOpmWaterfallTab === RouteConstants.SampleWaterfall) {
    selectedTab = RouteConstants.FirstLastSimulations;
  }

  return <PwcNavigate route={generatePath(selectedTab)} />;
};
